export default __webpack_public_path__ + "static/media/landing-how-it-works-bg.de3a5e64.png";